/* eslint-disable react-hooks/exhaustive-deps */
import React, { CSSProperties, useEffect, useState } from 'react';
import TimeElasped from './MinuteTimer';
import HUD from '../../Assets/HUD';
import DPad from './DPad';
import Lives from '../../Assets/Lives';
import useReactionTime from '../../Assets/Hooks/useReactionTime';
import '../../Assets/Styles/index.css';
import CorrectSound from '../../Assets/media/right_answer.mp3';
import WrongSound from '../../Assets/media/wrong_answer.mp3';

import useSound from 'use-sound';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

enum Direction {
  UP = 'UP',
  DOWN = 'DOWN',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface GameOver {
  isOver: boolean;
  finalScore: number;
  averageReactionTime?: string;
}

export interface CurrentInput {
  key: string;
}

export interface GameProps {
  userInput: CurrentInput;
  backgroundImage?: string;
  setGameOver: (value: GameOver | ((prevVar: GameOver) => GameOver)) => void;
  mute: boolean;
}
const PlayWrong = () => {
  const [playWrong, { stop }] = useSound(WrongSound, { soundEnabled: false });
  return { playWrong, stop };
};

const PlayCorrect = () => {
  const [playCorrect, { stop }] = useSound(CorrectSound, { soundEnabled: false });
  return { playCorrect, stop };
};

export default function Game(props: GameProps): JSX.Element {
  const directions: Array<Direction> = [Direction.LEFT, Direction.RIGHT, Direction.UP, Direction.DOWN];
  const [currWordIndex, setCurrWordIndex] = useState<number>(0);
  const [timedOut, setTimedOut] = useState<number>(0);
  const [correct, setCorrect] = useState<number>(0);
  const [timeLimit, setTimeLimit] = useState<number>(2000);
  const [, setTriggerCorrectAnimation] = useState<boolean>(false);
  const [triggerWrongAnimation, setTriggerWrongAnimation] = useState<boolean>(false);
  const [forceSoundEnabled, setForceSoundEnabled] = useState<boolean>(!props.mute);
  const CorrectSound = PlayCorrect();
  const WrongSound = PlayWrong();
  const { setTriggerReaction, getAverageTime } = useReactionTime();

  const getNewRandomIndex = () => {
    let newIndex = Math.floor(Math.random() * directions.length);
    while (newIndex === currWordIndex) {
      newIndex = Math.floor(Math.random() * directions.length);
    }
    setCurrWordIndex(newIndex);
    setTriggerReaction(true);
  };

  useEffect(() => {
    setForceSoundEnabled(!props.mute);
  }, [props.mute]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimedOut(timedOut + 1);
    }, timeLimit);
    return () => {
      clearTimeout(timeout);
    };
  }, [currWordIndex]);

  useEffect(() => {
    if (timedOut >= 4) {
      WrongSound.playWrong({ forceSoundEnabled: forceSoundEnabled });
      props.setGameOver({
        isOver: true,
        finalScore: 100 * correct,
        averageReactionTime: `${getAverageTime()}ms`,
      });
    } else {
      getNewRandomIndex();
      setTriggerCorrectAnimation(false);
      timedOut > 1 ? setTriggerWrongAnimation(true) : void 0;
      if (timedOut > 1) {
        WrongSound.playWrong({ forceSoundEnabled: forceSoundEnabled });
      }
    }
  }, [timedOut]);

  useEffect(() => {
    getNewRandomIndex();
    setTriggerWrongAnimation(false);
    correct != 0 ? setTriggerCorrectAnimation(true) : void 0;
    if (correct != 0) {
      CorrectSound.playCorrect({ forceSoundEnabled: forceSoundEnabled });
    }
    //speeds up the time limit per round if the user gets more correct
    if (correct === 30) {
      setTimeLimit(1500);
    } else if (correct === 50) {
      setTimeLimit(1000);
    } else if (correct === 75) {
      setTimeLimit(750);
    } else if (correct === 100) {
      setTimeLimit(650);
    }
  }, [correct]);

  useEffect(() => {
    if (timedOut < 4) {
      if (props.userInput.key === directions[currWordIndex]) {
        setTriggerReaction(false);
        setCorrect(correct + 1);
      } else {
        setTriggerReaction(false);
        setTimedOut(timedOut + 1);
      }
    }
  }, [props.userInput]);

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        background: props.backgroundImage ? `url(${props.backgroundImage})` : '#white',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <HUD width={700}>
        <div className="hud">
          <div className="score">
            <TimeElasped continue={timedOut >= 4 ? false : true} />
          </div>
          <div className="score">{100 * correct}</div>
          <div>
            <Lives totalLives={3} livesRemaining={3 - (timedOut - 1)} />
          </div>
        </div>
        <br></br>
      </HUD>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          key={currWordIndex}
        >
          <DPad wrong={timedOut} highlighted={directions[currWordIndex]} />
          <div style={{ height: '5vh' }}></div>
        </span>
        <FontAwesomeIcon
          icon={duotone('circle-xmark')}
          size="3x"
          style={
            {
              '--fa-secondary-color': '#E32C29',
              '--fa-primary-color': 'black',
              '--fa-secondary-opacity': 1,
              '--fa-primary-opacity	': 1,
              visibility: triggerWrongAnimation ? 'visible' : 'hidden',
            } as CSSProperties
          }
        />
      </div>
    </div>
  );
}
